import { render, staticRenderFns } from "./DeleteMultipleUsersDialog.vue?vue&type=template&id=65ad45ba&scoped=true"
import script from "./DeleteMultipleUsersDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleUsersDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteMultipleUsersDialog.vue?vue&type=style&index=0&id=65ad45ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad45ba",
  null
  
)

export default component.exports